import {
  UnicoCreateProcessDTO,
  UnicoCreateProcessResponse
} from "@repo/core/services/entities/Unico";
import { AxiosError } from "axios";

/**
 * Parameters for useUnicoCreateProcess hook
 */
export interface UseUnicoCreateProcessParams {
  /**
   * Callback called when process creation succeeds
   */
  onSuccess?: (data: UnicoCreateProcessResponse) => void;
  /**
   * Callback called when process creation fails (non-retryable errors)
   */
  onError?: (error: Error | AxiosError) => void;
  /**
   * Callback called when Unico is unavailable and manual fallback is required
   */
  onUnavailable?: (error: Error | AxiosError) => void;
}

/**
 * Return type for useUnicoCreateProcess hook
 */
export interface UseUnicoCreateProcessReturn {
  /**
   * Function to create Unico process with retry logic
   */
  createProcess: (
    payload: UnicoCreateProcessDTO
  ) => Promise<UnicoCreateProcessResponse | void>;
  /**
   * Loading state indicating if process creation is in progress
   */
  isLoading: boolean;
  /**
   * Number of retry attempts made
   */
  retryCount: number;
  /**
   * Current error (if any)
   */
  error: Error | AxiosError | null;
  /**
   * Reset hook state (loading, error, retryCount)
   */
  reset: () => void;
}

/**
 * Custom error class for retry exhaustion
 */
export class UnicoRetryExhaustedError extends Error {
  constructor(
    message: string,
    public readonly attempts: number,
    public readonly lastError: Error | AxiosError
  ) {
    super(message);
    this.name = "UnicoRetryExhaustedError";
  }
}
